<template>
    <div class="Trainee-TS-modal-overlay">
        <div class="Trainee-TS-modal-dialog" @click.stop>
            <div class="Trainee-TS-modal-content">
                <div class="Trainee-TS-modal-header">
                    <h5 class="Trainee-TS-modal-title" style="padding-top: 20px; font-size: 24px;">{{
                        capitalizedNoteType }} Note</h5>
                </div>
                <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
                <div v-if="isDisabled" class="flex-grow-1 d-flex justify-content-center" style="margin-bottom: 20px;">
                    <div class="expired-box">
                        This logbook is locked. Notes can no longer be edited.
                    </div>
                </div>
                <div class="artificial-fieldset">
                    <div class="question">
                        <table class="trainee-info-table">
                            <thead>
                            <tr>
                                <th v-if="this.noteType === 'public' && this.userRole === 'instructor'">This note will
                                    be viewable by the trainee</th>
                                <th v-else-if="this.noteType === 'private'">This note will only be viewable by Instructors assigned to this Session</th>
                                <th v-else-if="this.noteType === 'public' && this.userRole === 'trainee'">Instructors
                                    note for the task</th>
                            </tr>
                            </thead>
                        </table>
                    </div>
                    <div class="trainee-answer-section">
                        <div ref="editor" class="quill-editor" :class="{ 'read-only': readOnly || this.isDisabled === true }"></div>
                    </div>
                </div>
                <div class="button-container">
                    <button class="ins-close-button" @click="close">Close</button>
                    <div class="right">
                        <button v-if="!readOnly && !isDisabled" class="ins-submit-button" @click="saveAnswers">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import axios from 'axios';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

export default {
    name: 'App',
    props: {
        logbookEntryId: {
            type: [Number],
            required: true
        },
        logbookId: {
            type: [Number],
            required: true
        },
        isDisabled: {
            type: [Boolean],
            required: true
        },
        userRole: {
            type: [String],
            required: true
        },
        noteType: {
            type: [String],
            required: true
        },
    },
    data() {
        return {
            instructorId: parseInt(localStorage.getItem('user_id')),
            showQuillEditor: true,
            quill: null,
            editableNote: this.initialContent || '',
            currentNote: '',
            notes: [], // all fetched notes
            instructors: [],
            readOnly: (this.noteType === 'public' && this.userRole === 'trainee') || this.isDisabled
        };
    },
    computed: {
        capitalizedNoteType() {
            if (!this.noteType) return '';
            return this.noteType.charAt(0).toUpperCase() + this.noteType.slice(1);
        }
    },
    watch: {
  isDisabled(newVal) {
    if (this.quill) {
      this.quill.enable(!newVal && !this.readOnly);
    }
  },
},
    methods: {
        initializeQuillEditor() {
            if (!this.quill) {
                this.quill = new Quill(this.$refs.editor, {
                    theme: 'snow',
                    readOnly: this.readOnly,
                    modules: {
                        toolbar: [],
                    },
                });
                this.quill.getModule('toolbar').container.style.display = 'none'; // This hides the toolbar

                this.quill.on('text-change', () => {
                    this.editableNote = this.quill.root.innerHTML;
                });

                this.quill.root.innerHTML = this.editableNote || '';
                this.adjustEditorHeight();
            }
        },
        loadNotes() {
            const token = localStorage.getItem('token');
            const headers = { Authorization: `Bearer ${token}` };

            axios
                .get(`/api/notes/entry/${this.logbookEntryId}`, { headers })
                .then((response) => {
                    this.notes = response.data;
                    console.log('notes', this.notes);
                    let myNote = null;

                    if (this.userRole === 'trainee' && this.noteType === 'public') {
                        // Trainee sees instructor public note
                        myNote = this.notes.find(
                            (n) => n.type === 'public' && n.role === 'instructor'
                        );

                    } else if (this.userRole === 'instructor' && this.noteType === 'private') {
                        // Any instructor can see private instructor notes
                        myNote = this.notes.find(
                            (n) => n.type === 'private' && n.role === 'instructor'
                        );

                    } else {
                        // Default: match own note
                        myNote = this.notes.find(
                            (n) =>
                                n.type === this.noteType &&
                                n.user_id === parseInt(localStorage.getItem('user_id')) &&
                                n.role === this.userRole
                        );
                    }

                    if (myNote) {
                        this.currentNote = myNote;
                        this.editableNote = myNote.content || '';
                        if (this.quill) {
                            this.quill.root.innerHTML = this.editableNote;
                        }
                    }
                })
                .catch((error) => {
                    console.error('Failed to load notes', error);
                });
        },
        async fetchUsers() {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                console.error('Unauthorized access');
                return;
                }
                const headers = { Authorization: `Bearer ${token}` };
                const project_id = parseInt(localStorage.getItem('project_id'));

                const response = await axios.get(`/api/projects/${project_id}/users`, { headers });

                console.log('response', response);

                if (response.status === 200) {
                this.instructors = response.data.filter(user => user.pivot.role === 'instructor');
                console.log('instructors', this.instructors);
                }
            } catch (error) {
                console.error('Error retrieving users:', error);
            }
        },
        adjustEditorHeight() {
            const editorElement = this.$refs.editor.querySelector('.ql-editor');
            const toolbar = this.$refs.editor.querySelector('.ql-toolbar');
            const toolbarButtons = this.$refs.editor.querySelectorAll('.ql-toolbar .ql-formats');

            if (editorElement) {
                editorElement.style.height = '260px';
                editorElement.style.fontFamily = 'monospace';
            }
            if (toolbar) {
                toolbar.style.height = '40px';
                toolbar.style.minHeight = '30px';
            }
            if (toolbarButtons) {
                toolbarButtons.forEach((btnGroup) => {
                    btnGroup.style.margin = '0 2px';
                });
            }
        },
        close() {
            this.$emit('close');
        },
        saveAnswers() {
            const formattedNote = this.quill.root.innerHTML;
            const token = localStorage.getItem('token');
            const headers = { Authorization: `Bearer ${token}` };

            const noteData = {
                user_id: this.instructorId,
                logbook_id: parseInt(this.logbookId),
                logbookentry_id: this.logbookEntryId,
                role: this.userRole,
                type: this.noteType,
                content: formattedNote,
            };

            if (this.currentNote && this.currentNote.note_id) {
                // Note already exists -> update
                axios
                    .put(`/api/notes/${this.currentNote.note_id}`, noteData, { headers })
                    .then((res) => {
                        console.log('Note updated:', res.data);
                        alert('Note updated successfully.');
                        this.close();
                    })
                    .catch((err) => {
                        console.error('Failed to update note:', err);
                        alert('Failed to update the note entry.');
                    });
            } else {
                // No note yet -> create
                axios
                    .post('/api/notes', noteData, { headers })
                    .then((res) => {
                        console.log('Note created:', res.data);
                        alert('Note saved successfully.');
                        this.close();
                    })
                    .catch((err) => {
                        console.error('Failed to create note:', err);
                        alert('Failed to create a note entry.');
                    });
            }
        }
    },
    mounted() {
        this.initializeQuillEditor();
        this.loadNotes();
        this.fetchUsers();
        console.log('logbookentryid', this.logbookEntryId);
        console.log('logbookid', this.logbookId);
        console.log('userRole', this.userRole);
        console.log('noteType', this.noteType);
        console.log('disabled', this.isDisabled);
    },
}
</script>

<style scoped>
table.trainee-info-table {
    font-family: Arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
    margin-top: 10px;
}

.trainee-info-table th,
.trainee-info-table td {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 6px;
    font-size: 14px;
}

.trainee-info-table td {
    font-weight: 100;
}

.trainee-info-table th {
    background-color: #f2f2f2;
}

.Trainee-TS-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    /* Semi-transparent background */
    display: flex;
    justify-content: center;
    z-index: 1000;
}

.Trainee-TS-modal-body h2 {
    list-style-type: none;
    margin-top: 10px;
    padding: 0;
    margin-right: 1%;
    text-align: center;

}

.Trainee-TS-modal-body ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    text-align: left;
    margin-left: 5%;
}

.Trainee-TS-modal-body p.heading {
    list-style-type: none;
    margin-top: 20px;
    text-align: left;
    margin-left: 1%;
}

.assessment-criteria-box {
    border: 1px solid #b1b1b1;
    /* You can adjust the border color and thickness */
    padding: 10px;
    /* Optional: Add padding for better appearance */
    margin: 10px 0;
    /* Optional: Add margin for spacing */
}


.Trainee-TS-modal-content {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 800px;
    width: 100%;
    margin: auto;
    padding: 0;
    background: #fff;
    border-radius: 5px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.Troubleshoot-modal-dialog {
    display: flex;
    flex-direction: row;
    /* Arrange children (questions and answers) in a row */
}

.Trainee-TS-modal-dialog {
    max-height: 90vh;
    overflow-y: auto;
}

.Troubleshoot-modal-body {
    display: flex;

}

.question-item {
    margin: 10px 0;
    text-align: left;
    font-weight: bold;
}

.Trainee-questions-container>ol>li>ul {
    list-style-type: disc;
    /* Adds a bullet point (dot) */
    padding-left: 40px;
    /* Indent subpoints further than the main list */
}

.Trainee-questions-container ul li {
    margin: 5px 0;
}

.Trainee-questions-container {
    text-align: left;
}

button {
    /* Adjust as needed */
    width: 100px;
    /* Adjust as needed */
    padding: 10px;
    /* Adjust as needed */
    background-color: #f2f2f2;
    /* Style as needed */
    border: none;
    /* Style as needed */
    cursor: pointer;
    /* Style as needed */
    /* Add more styling as needed */
}

.questions-list {
    text-align: left;
}

.Trainee-questions-container h6,
.Trainee-answers-container h6 {
    width: 100%;
    background-color: rgb(216, 216, 216);
    /* Light grey background */
    /* Border for the header */
    text-align: center;

}


.list-group-item {
    background-color: transparent;
    /* Remove default background */
}

.list-group-numbered {
    counter-reset: list-group-counter;
    text-align: left;
}

.list-group-numbered>.list-group-item:before {
    content: counter(list-group-counter) ". ";
    counter-increment: list-group-counter;
}

/* Style for the nested ul */
.Trainee-questions-container ul {
    list-style-type: none;
    /* Removes bullet points */
    padding-left: 20px;
    /* Indent subpoints */
}

.Trainee-answers-container {
    outline: none;
    z-index: 1000;
    width: 60%;
}

.right {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    /* Adjust the gap between buttons */
}

.nav-link {
    cursor: pointer;
}

.artificial-fieldset {
    border: 1px solid #ddd;
    border-top: none;
    padding: 10px;
    position: relative;
}

.artificial-fieldset-legend {
    position: absolute;
    top: -10px;
    left: 10px;
    background-color: #fff;
    padding: 0 10px;
    font-weight: bold;
}


.question {
    text-align: left;
    font-weight: bold;
}

.navigation-buttons {
    margin-top: 5px;
}

.nav-button {
    padding: 5px 15px;
    /* Adjust padding to change button size */
    margin: 0 5px;
    /* Space between buttons */

}


.ql-toolbar {
    height: 40px;
    min-height: 40px;
}


.ql-toolbar .ql-formats {
    margin: 0 2px;
}

.ql-container .ql-editor {
    height: 200px;
    min-height: 200px;
}

h4 {
    font-size: 1.5rem;
    margin-top: 30px;
    margin-bottom: 30px;
}

.button-container {
    display: flex;
    justify-content: space-between;
    /* Aligns items to the right */
    align-items: center;
    margin: 20px;
}

.ins-save-button {
    background-color: #007bff;
    color: white;
    border: 1px solid #0157b3;
    cursor: pointer;
    border-radius: 5px;
    padding: 5px 10px;
    margin-left: 20px;
}

.ins-save-button:hover {
    background-color: #0462c7;
}

.ins-submit-button {
    background-color: brown;
    border: 1px solid rgb(99, 15, 15);
    color: white;
    cursor: pointer;
    border-radius: 5px;
    padding: 5px 20px;
    margin-left: 20px;
}

.ins-submit-button:hover {
    background-color: rgb(129, 33, 33);
}

.ins-close-button {
    background-color: #6c757d;
    border: 1px solid #4d5358;
    color: white;
    padding: 5px 20px;
    border-radius: 5px;
}

.ins-close-button:hover {
    background-color: #545a5f;
}

.tabs {
    margin-left: 10px;
    margin-right: 10px;
}

.nav-link {
    color: black;
    background-color: #eeeeee;
}

.nav-link:hover {
    color: black;
    background-color: #dadada;
}

.nav-link.active {
    color: #007bff;
    background-color: #ffffff;
}
</style>